var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("chart-epss-vs-cvss", {
        ref: "chartEpssVsCvss",
        staticClass: "chart-wrapper",
        staticStyle: { height: "400px", "margin-top": "40px" },
        attrs: { chartId: "chartEpssVsCvss", height: 400 },
      }),
      _c(
        "div",
        {
          staticClass: "bs-table-custom-toolbar",
          attrs: { id: "epssToolbar" },
        },
        [
          _c(
            "c-switch",
            _vm._b(
              {
                staticStyle: {
                  "margin-left": "1rem",
                  "margin-right": "0.5rem",
                },
                attrs: {
                  id: "showSuppressedFindings",
                  color: "primary",
                  label: "",
                },
                model: {
                  value: _vm.showSuppressedFindings,
                  callback: function ($$v) {
                    _vm.showSuppressedFindings = $$v
                  },
                  expression: "showSuppressedFindings",
                },
              },
              "c-switch",
              _vm.labelIcon,
              false
            )
          ),
          _c("span", { staticClass: "text-muted" }, [
            _vm._v(_vm._s(_vm.$t("message.show_suppressed_findings"))),
          ]),
        ],
        1
      ),
      _c("bootstrap-table", {
        ref: "table",
        attrs: { columns: _vm.columns, data: _vm.data, options: _vm.options },
        on: { "on-load-success": _vm.tableLoaded },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }